import React from 'react';
import { RefreshCw, Bell, BellOff, Volume2, VolumeX } from 'lucide-react';

const NotificationControls = ({ autoRefresh, setAutoRefresh, notificationsEnabled, setNotificationsEnabled, soundEnabled, setSoundEnabled }) => {
  return (
    <div className="flex items-center justify-between p-3 rounded-xl border border-border bg-muted/20 mb-4" data-testid="notification-controls">
      <div className="flex items-center space-x-1">
        <span className="text-xs font-medium text-foreground/60 mr-2">Live Updates:</span>
        <button onClick={() => setAutoRefresh(!autoRefresh)}
          className={`inline-flex items-center space-x-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${autoRefresh ? 'bg-green-100 text-green-700 ring-1 ring-green-300' : 'bg-background border border-border text-foreground/50'}`}
          data-testid="toggle-auto-refresh">
          <RefreshCw className={`w-3.5 h-3.5 ${autoRefresh ? 'animate-spin' : ''}`} style={autoRefresh ? { animationDuration: '3s' } : {}} />
          <span>{autoRefresh ? 'Auto-Refresh On' : 'Auto-Refresh Off'}</span>
        </button>
        <button onClick={() => { setNotificationsEnabled(!notificationsEnabled); if (!notificationsEnabled && 'Notification' in window && Notification.permission === 'default') Notification.requestPermission(); }}
          className={`inline-flex items-center space-x-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${notificationsEnabled ? 'bg-blue-100 text-blue-700 ring-1 ring-blue-300' : 'bg-background border border-border text-foreground/50'}`}
          data-testid="toggle-notifications">
          {notificationsEnabled ? <Bell className="w-3.5 h-3.5" /> : <BellOff className="w-3.5 h-3.5" />}
          <span>{notificationsEnabled ? 'Alerts On' : 'Alerts Off'}</span>
        </button>
        <button onClick={() => setSoundEnabled(!soundEnabled)}
          className={`inline-flex items-center space-x-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${soundEnabled ? 'bg-amber-100 text-amber-700 ring-1 ring-amber-300' : 'bg-background border border-border text-foreground/50'}`}
          data-testid="toggle-sound">
          {soundEnabled ? <Volume2 className="w-3.5 h-3.5" /> : <VolumeX className="w-3.5 h-3.5" />}
          <span>{soundEnabled ? 'Sound On' : 'Sound Off'}</span>
        </button>
      </div>
      {autoRefresh && <span className="text-xs text-foreground/40">Checking every 30s</span>}
    </div>
  );
};

export default NotificationControls;
